import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const priceListPageK = {
  searchInPriceList: "price_list_page.searchInPriceList",
  door: "price_list_page.door",
  productNumber: "price_list_page.productNumber",
  export: "price_list_page.export",
  pricelist: "price_list_page.pricelist",
  productCategory: "price_list_page.productCategory",
  currency: "price_list_page.currency",
  dimensions: "price_list_page.dimensions",
  wireframe: "price_list_page.wireframe",
  unitOfMeasure: "price_list_page.unitOfMeasure",
  unitPrice: "price_list_page.unitPrice",
  productType: "price_list_page.productType",
  productName: "price_list_page.productName",
  quantity: "price_list_page.quantity",
};

export const usePriceListPageT = () => {
  const { t, i18n } = useTranslation();
  
  return useMemo(
    () => ({
      searchInPriceList: t(priceListPageK.searchInPriceList),
      door: t(priceListPageK.door),
      productNumber: t(priceListPageK.productNumber),
      export: t(priceListPageK.export),
      pricelist: t(priceListPageK.pricelist),
      productCategory: t(priceListPageK.productCategory),
      currency: t(priceListPageK.currency),
      dimensions: t(priceListPageK.dimensions),
      wireframe: t(priceListPageK.wireframe),
      unitOfMeasure: t(priceListPageK.unitOfMeasure),
      unitPrice: t(priceListPageK.unitPrice),
      productType: t(priceListPageK.productType),
      productName: t(priceListPageK.productName),
      quantity: t(priceListPageK.quantity),
    }),
    [i18n.language]
  );
};